import sanitizeHtml from 'sanitize-html';

export default (input, replace, allowedTags = ['br']) => {
  let replaceSymbol;
  if (replace) {
    replaceSymbol = String(input).replace(/</g, '&#60;');
  }
  return sanitizeHtml(replace ? replaceSymbol : input, {
    allowedAttributes: [],
    allowedTags: [...allowedTags],
    selfClosing: [...allowedTags],
  });
};



// WEBPACK FOOTER //
// ./src/utils/sanitizeHtml.js